import React from "react";
import { getCDNProviderToUse } from "../../../utils/base";

export const ProfileImg = ({
  wrapperClass,
  namePosition,
  memberTitle,
  memberRole,
  imgSrc,
  imgSize
}) => (
  <div
    className={`group relative bg-center bg-cover bg-no-repeat rounded-xs cursor-pointer ${wrapperClass} ${
      imgSize === "small" ? "pt-[73%]" : "pt-[123%]"
    }`}
    style={{
      backgroundImage: `url(${getCDNProviderToUse({ width: 500, uri: imgSrc })})`,
      boxShadow: "0px 4px 50px rgba(0, 0, 0, 0.25)"
    }}
  >
    <h6
      className={`absolute hidden group-hover:block top-0 h-full px-4 pt-6 rounded-xs bg-white/90 planet:bg-[#000C03]/80 !text-black-lighter planet:!text-white ltr-grid w-full ${
        namePosition === "right"
      }`}
      dangerouslySetInnerHTML={{ __html: memberRole }}
    />
    <div
      className={`absolute bottom-2 h7 bg-white planet:bg-gray-darker !text-black-lighter planet:!text-white uppercase px-2 ${
        namePosition === "left" ? "-left-2" : "-right-2"
      }`}
      dangerouslySetInnerHTML={{ __html: memberTitle }}
    />
  </div>
);
